var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 2,
    viewBox: "0 0 63 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6555 0H0V1.69613H62.6555V0Z",
    fill: "var(--neutral-950-main, #1D1F2A)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorConnector);
export default __webpack_public_path__ + "static/media/error-connector.95bf9fc5b794df91c4712292fd8c6e80.svg";
export { ForwardRef as ReactComponent };